import { CheckCircle2 } from "lucide-react";

export const UseCasesSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-blue-900 to-blue-950">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-white mb-4">
            Transform Your Business With AI
          </h2>
          <p className="text-xl text-blue-200 max-w-2xl mx-auto">
            Discover how our AI solutions can revolutionize different aspects of your operations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Customer Support",
              items: [
                "24/7 instant response to customer queries",
                "Automated ticket routing and resolution",
                "Personalized customer interactions",
                "Multilingual support capabilities"
              ]
            },
            {
              title: "Sales & Marketing",
              items: [
                "Lead qualification and scoring",
                "Personalized product recommendations",
                "Automated follow-ups",
                "Sales pipeline management"
              ]
            },
            {
              title: "Operations",
              items: [
                "Process automation and optimization",
                "Data analysis and reporting",
                "Resource scheduling",
                "Inventory management"
              ]
            }
          ].map((useCase, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-blue-900/30 border border-blue-800/50"
            >
              <h3 className="text-xl font-semibold text-white mb-4">
                {useCase.title}
              </h3>
              <ul className="space-y-3">
                {useCase.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-2">
                    <CheckCircle2 className="h-5 w-5 text-blue-400 shrink-0 mt-0.5" />
                    <span className="text-blue-200">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};